import { catalog } from "../i18n.js";

/** The Plugins panel (components/Plugins.tsx). Each plugin's own name and description come from Composio and stay as they are. */
export const PLUGINS = catalog(
  {
    title: "Plugins",
    about: "Connect your accounts so your bots can work in them. Every bot can use what is connected here.",
    close: "Close",
    notSetUp: "Plugins are not set up on this host.",
    notSetUpBefore: "Plugins come from Composio. Set ",
    notSetUpAfter: " to a Composio API key on the machine that starts the box, then start it again.",

    searchAll: "Search apps: Gmail, Slack, Notion…",
    searchConnected: "Search your connected apps",
    searchLabel: "Search apps",
    show: "Show",
    allApps: "All apps",
    connected: "Connected",
    needsReconnecting: "Needs reconnecting",

    popupTitle: (app: string) => `Connecting ${app}…`,
    popupBody: (app: string) => `Opening ${app}'s sign-in…`,
    noSignIn: "No sign-in needed",
    connect: "Connect",
    connecting: "Connecting…",
    waitingSignIn: "Waiting for sign-in…",
    openAgain: "Open again",
    openSignIn: "Open sign-in page",
    cancel: "Cancel",
    composioReports: (status: string) => `Composio reports ${status}`,
    reconnect: "Reconnect",
    disconnect: "Disconnect",
    disconnecting: "Disconnecting…",
    keep: "Keep",

    noneMatch: "None of your connected apps match.",
    nothingConnected: "Nothing connected yet. Find an app under All apps and connect it.",
    noAppMatches: (query: string) => `No app matches “${query}”.`,
    loadingApps: "Loading apps…",
    loading: "Loading…",
    showMore: "Show more",
    showMoreOf: (shown: number, total: number) => `Show more (${shown} of ${total})`,
    foot: "Sign-in happens on the app's own page, through Composio; ark-bot never sees your password.",
  },
  {
    title: "Plugin",
    about: "Hubungkan akunmu supaya bot kamu bisa bekerja di sana. Semua bot bisa memakai yang terhubung di sini.",
    close: "Tutup",
    notSetUp: "Plugin belum diatur di host ini.",
    notSetUpBefore: "Plugin berasal dari Composio. Isi ",
    notSetUpAfter: " dengan API key Composio di mesin yang menjalankan box, lalu jalankan lagi.",

    searchAll: "Cari aplikasi: Gmail, Slack, Notion…",
    searchConnected: "Cari aplikasi yang terhubung",
    searchLabel: "Cari aplikasi",
    show: "Tampilkan",
    allApps: "Semua aplikasi",
    connected: "Terhubung",
    needsReconnecting: "Perlu dihubungkan ulang",

    popupTitle: (app: string) => `Menghubungkan ${app}…`,
    popupBody: (app: string) => `Membuka halaman masuk ${app}…`,
    noSignIn: "Tidak perlu masuk",
    connect: "Hubungkan",
    connecting: "Menghubungkan…",
    waitingSignIn: "Menunggu kamu masuk…",
    openAgain: "Buka lagi",
    openSignIn: "Buka halaman masuk",
    cancel: "Batal",
    composioReports: (status: string) => `Status dari Composio: ${status}`,
    reconnect: "Hubungkan ulang",
    disconnect: "Putuskan",
    disconnecting: "Memutuskan…",
    keep: "Biarkan",

    noneMatch: "Tidak ada aplikasi terhubung yang cocok.",
    nothingConnected: "Belum ada yang terhubung. Cari aplikasi di Semua aplikasi, lalu hubungkan.",
    noAppMatches: (query: string) => `Tidak ada aplikasi yang cocok dengan “${query}”.`,
    loadingApps: "Memuat aplikasi…",
    loading: "Memuat…",
    showMore: "Tampilkan lebih banyak",
    showMoreOf: (shown: number, total: number) => `Tampilkan lebih banyak (${shown} dari ${total})`,
    foot: "Kamu masuk di halaman aplikasinya sendiri, lewat Composio; ark-bot tidak pernah melihat kata sandimu.",
  },
);
